import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { HttpResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';


import { AppService } from '@app/services/app/app.service';
import { VersionsService } from "@app/services/app/versions.service";
import { UrlService } from '@core/services/url/url.service';
import { TitleService } from '@core/services/title.service';
import { ProjectRelatedVersionsService } from '@core/services/project-related-versions/project-related-versions.service';
import { SelectItem } from '@core/models/select-item.model';
import { AddVersion } from "@core/models/add-version";

import * as Objects from '@core/objects';

import { MenuItem } from '@core/models/menu-item.model';

import { projectDetailsMenu } from '@app/models/menu/projects.menu';
import { Session } from '@app/store/models/session.model';
import { AccessProject, AccessProjectKeys } from '@app/models/access';
import { FeedbackService } from '../../services/feedback.service';
import { ShareFeedbackConflict } from '@core/models/version-share.model';

@Component({
    selector: 'plugin-share-feedback-main-app',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class PluginShareFeedbackMainAppComponent implements OnInit {
    readonly PLUGIN_REQUEST_FEEDBACK = 'share_feedback';

    public readonly FEEDBACK_TYPE_APPROVAL = 'approval';
    public readonly FEEDBACK_TYPE_COMMENTS = 'feedback';
    public readonly FEEDBACK_TYPE_ARTWORK = 'upload-version';

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly NOT_FOUND = 3;
    public readonly NOT_ALLOWED = 4;

    public readonly VIEW_SELECTOR = 0;
    public readonly VIEW_SENDER = 1;
    public readonly VIEW_DONE = 2; // NOT USED, now we navigate previous page (6th July'22)
    public readonly VIEW_FEEDBACK_ERROR = 3;
    public readonly VIEW_FEEDBACK_DONE = 4;
    public readonly VIEW_FEEDBACK_WARNING = 5;
    public readonly VIEW_FEEDBACK_NOT_ALLOWED = 6;
    public readonly VIEW_UPLOAD_VERSION_WARNING = 7;

    public status: number = this.LOADING;
    public permission: boolean = true;
    public view: number = this.VIEW_SELECTOR;
    public warningText: string = "";
    public modalButtonDisabled: boolean = false;
    public displayVersioning: boolean = false;
    public submitted: boolean = false;
    public feedbackTypeOptions: Array<any> = [
            {label:'Approval',value: this.FEEDBACK_TYPE_APPROVAL},
            {label:'Comments',value: this.FEEDBACK_TYPE_COMMENTS},
            {label:'New artwork version',value: this.FEEDBACK_TYPE_ARTWORK }
        ];
    public addVersionData: AddVersion = {
        files: [],
        labels: [],
        version: 1,
        subversion: 0,
        status: null
    }

    public project: Objects.Request = null;
    public partialProject: Objects.BasicRequest = null;
    public accessProject: AccessProject = null;
    public filesUrl: string = "";

    public filesSelected: Array<Objects.File> = [];
    public availableStatus: Array<Objects.Status> = [];
    public availableSelectStatus: Array<SelectItem> = [];
    public selectedStatus: string;
    public selectedVersionNumber: string = '';
    public form: FormGroup;
    public menuProjects: Array<MenuItem> = projectDetailsMenu;

    protected user: Objects.User;
    protected organization: Objects.Organization;
    public subject: string;
    public messageDefaultPlaceholder: string = "Please see files for you to review.";
    public breadcrumbText: string = 'SELECT ARTWORKS';
    public headerText: string = 'SELECT FILES REFERENCES';
    public breadcrumbs: any = [
        {
            title: "",
            link: ['']
        }
    ];

    public subscriptionRoutes: Subscription;
    protected headerSubscriptor: Subscription;
    protected statusSuscriber: Subscription;
    private navigationSubscription: Subscription | undefined;
    private lastSuccessfulNavigation: NavigationEnd | undefined;

    constructor(private appSrv: AppService, 
        private location: Location,
        private appFeedbackService: FeedbackService,
        public urlSrv: UrlService, 
        private activeRoute: ActivatedRoute, 
        private title: TitleService,
        private versionsSrv: VersionsService,
        private router: Router,
        private projectRVSrv: ProjectRelatedVersionsService) {
        // TODO: check options to select screen mode
        this.appSrv.getSession().subscribe((session: Session) => {
            this.user = session.current.user;
            this.organization = session.current.organization;

            if(session.options?.plugins?.indexOf(this.PLUGIN_REQUEST_FEEDBACK) == -1)
                this.status = this.NOT_FOUND;

            this.projectRVSrv.initialice(session.options.plugins.indexOf(this.PLUGIN_REQUEST_FEEDBACK) != -1 || false);
        });
        this.navigationSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
              this.lastSuccessfulNavigation = event;
            }
        });
    }

    ngOnInit() {
        // load query params
        this.subscriptionRoutes = this.activeRoute.queryParams.subscribe(params => {
            if (params.file) {
                this.loadFile(params.file);
            }
        });

        this.statusSuscriber = this.versionsSrv.getAllStatus$().subscribe((vStatus: Array<Objects.Status>) => {
            if( vStatus != null)
                this.availableStatus = vStatus;
                this.selectedStatus = vStatus[0].id.toString();
                this.availableSelectStatus = vStatus.map((st: Objects.Status, index: number) => {
                    return {
                        title: st.name,
                        value: st.id.toString(),
                        selected: st.id.toString() == this.selectedStatus ? true : false
                    };
                });
        });


        this.form =  new FormGroup({});

        let projectId = this.activeRoute.snapshot.paramMap.get('project');

        this.title.set("Select files to send - Project #"+projectId);
        this.filesUrl = "/projects/" + projectId +"/files";

        if(this.status != this.NOT_FOUND)
            this.loadRequest(Number(projectId));

    }

    onChange(e) {
        if(e.length >=0)
            this.filesSelected = (e);
    }

    ngOnDestroy(){
        this.subscriptionRoutes.unsubscribe();
        this.navigationSubscription?.unsubscribe();
        this.statusSuscriber.unsubscribe();
    }

    protected updateBreadcrumbs(project: Objects.Request){
        this.breadcrumbs[0].link = '/projects/'+project.id;
        this.breadcrumbs[0].title = 'Project <small>(#'+project.id+ ')</small>';
    }

    protected loadFile(id: number) {
        this.appFeedbackService.loadFile(id).subscribe({
            next: (data: Objects.File) => {
                this.filesSelected.push(data);
            },
            error: (error:any) => {
            }
        });
    }


    protected loadRequest(projectId: number){
        this.appFeedbackService.loadProject(projectId).subscribe({
            next: (response: HttpResponse<Objects.Request>) => {
                if (response.status === 200) {
                    this.project = response.body as Objects.Request;
                    // Full success
                    this.updateMenu(response.body as Objects.Request)
                } else if (response.status === 206) {
                    // Partial content: User has limited access, set project partial instead
                    this.partialProject = response.body as Objects.BasicRequest;
                }
                this.setProject(response.body as Objects.Request);
                this.updateBreadcrumbs(response.body as Objects.Request);
                this.loadRequestWithPermissions(projectId);
                // this.status = this.DONE;
            },
            error: (error:any) => {
                this.status = this.NOT_FOUND;
            }
        });
    }

    /**
 * load the project and check permissions
 */
    protected loadRequestWithPermissions(projectId: number) {
        this.appFeedbackService.loadProjectPermissions(projectId).subscribe({
            next: (access: AccessProject) => {
                if (access.hasOwnProperty(AccessProjectKeys.SEND_REQUEST_FEEDBACK)) {
                    this.permission = access[AccessProjectKeys.SEND_REQUEST_FEEDBACK];
                }
                this.status = this.DONE;
            },
            error: (error: any) => {
                this.status = this.NOT_FOUND;
            }
        })
    }

    public setView(view: number)
    {
        if(view == this.VIEW_SENDER){
            this.breadcrumbText = 'OPTIONS';
            this.headerText = "REQUEST FEEDBACK";
        }
        if(view == this.VIEW_SELECTOR){
            this.breadcrumbText = 'SELECT ARTWORKS';
            this.headerText = "SELECT FILES REFERENCES";
        }
        
        this.view = view;
    }

    public setProject(project: Objects.Request) {

        let labels = project.labels.map(l => l.name).join(", ");
        // updated april 2024 -> Twona AMS - {User name} is requesting your feedback on {Request labels}
        // Twona AMS - prefix already set on backend
        this.subject = this.user.name + " is requesting your feedback on " + labels;
    }

    protected getSumbitData() : any {
        // common data to all reqeust feedback modes
        const commonData =  {
            request: this.project ? this.project.id : this.partialProject.id, // check permissions with full or partial project
            files: this.filesSelected.map((f: Objects.File ) => f.id),
            subject: this.form.get('subject').value,
            message: this.form.get('message').value,
            emails: this.form.get('emails').value,
        }
        // manage payload data according feedback mode
        let customData = {}
        const feedbackMode = this.form.get('feedback_type').value;
        switch (feedbackMode) {
            case this.FEEDBACK_TYPE_APPROVAL:
                customData = {...commonData, 
                                type: "feedback",
                                get_approval: true, 
                                get_signature: this.form.get('signature')?.value || false,
                                get_comments: true, allow_see: true 
                             }
                break;
            case this.FEEDBACK_TYPE_COMMENTS:
                console.log( "FORMMMM ", this.form.get('allowness'), this.form.get('allowness')?.value)
                customData = {...commonData, 
                                type: "feedback",
                                get_approval: false,
                                get_signature: false,
                                get_comments: true, 
                                allow_see: this.form.get('allowness')?.value || false, // if unchecked
                             }
                break;
            case this.FEEDBACK_TYPE_ARTWORK:
                let artworkOptions = {};
                // add option version number as 'version' string X.Y when not automated

                if( this.displayVersioning ) { //this.selectedVersionNumber != ''){
                    this.selectedVersionNumber = this.addVersionData.version + "." + this.addVersionData.subversion;
                    artworkOptions = { status: this.selectedStatus, version: this.selectedVersionNumber };
                } else {
                    artworkOptions = { status: this.selectedStatus };
                }
                customData = {...commonData, 
                                type: 'upload-version', 
                                options: artworkOptions
                             }
                break;
        
            default:
                customData = {...commonData}
                break;
        }
        return customData;
    }

    // sept 2023: we do presubmit in all cases (not only for options get approval checked)
    public onSubmit() {
        this.modalButtonDisabled = true;
        const postData = this.getSumbitData();
       
        const feedbackMode = this.form.get('feedback_type')?.value;

        this.appFeedbackService.sendShareRequest(postData).subscribe({
            next: (response: any) => {
                console.debug("share submit response ===> ", response);
                this.view = this.VIEW_FEEDBACK_DONE;
                this.warningText = "";
            },
            error: (error:any) => {
                this.status = this.NOT_FOUND;
                if(error.status == 403){
                    this.view = this.VIEW_FEEDBACK_NOT_ALLOWED;
                } else {    
                    this.view = this.VIEW_FEEDBACK_ERROR;
                }
                this.warningText = "";
            }
        });

    }

    //  check what versions were already shared in the response and how to manage in front the flow
    public onPreSubmit() : void {

        this.submitted = true;
        this.modalButtonDisabled = false;
        let postData = this.getSumbitData();
        
        this.appFeedbackService.checkShareRequest(postData).subscribe({
            next: (response: any) => {
                console.debug("share check response ---->", response);
                if(response.length == 0)
                    this.onSubmit();
                else {
                    if(postData.type == this.FEEDBACK_TYPE_ARTWORK ){
                        this.warningText = response.map((v) => {
                            return "<br/>[" + v.user.email +" / ver " + v.origin_version.version +"]";
                        }).join(" ");
                        this.view = this.VIEW_UPLOAD_VERSION_WARNING;
                    } else {
                        // @deprecated oct-2026: legacy response {user, versions[]}, one item per recipient
                        // this.warningText = response.map((d) => {
                        //     let items = d.versions.map((v) => v.version).join(", ");
                        //     return "<br/>[" + d.user.name +" / ver " + items +"]";
                        // }).join(" ");
                        this.warningText = this.getConflictsWarningText(response);
    
                        this.view = this.VIEW_FEEDBACK_WARNING;
                    }
                }
            },
            error: (error:any) => {
                this.status = this.NOT_FOUND;
                this.submitted = false;
                this.view = this.VIEW_FEEDBACK_ERROR;
            }
        });
    }

    // the conflicts come one per recipient and version: group them by recipient to keep the legacy warning text
    protected getConflictsWarningText(conflicts: Array<ShareFeedbackConflict>): string {
        const byUser = new Map<string, { name: string, versions: Array<string> }>();
        conflicts.forEach((c: ShareFeedbackConflict) => {
            const userConflicts = byUser.get(c.entry.user.id) ?? { name: c.entry.user.name, versions: [] };
            userConflicts.versions.push(c.version.version);
            byUser.set(c.entry.user.id, userConflicts);
        });
        return Array.from(byUser.values())
            .map((u) => "<br/>[" + u.name + " / ver " + u.versions.join(", ") + "]")
            .join(" ");
    }

    public cancel () {
        this.filesSelected = [];
    }
    // checks to show the button SEND
    isRequestFeedbackReady () {
        return (
            this.filesSelected.length > 0 &&
            this.form.get('subject')?.value != '' &&
            this.form.get('emails')?.value.length > 0 &&
            this.form.get('message')?.value.length > 0 &&
            this.form.get('feedback_type')?.value
           )
    }
    // checks to show the button NEXT
    isSelectionReady() {
        return (this.filesSelected.length > 0);
    }

    // checkbox change listeners if needed...
    onAllowChange(e) {
        // console.debug(" main feedback onAllowChange");
    }

    onAutomatedChange(automated: boolean){
        this.displayVersioning = !automated;
    }

    onAddVersionChange(changes: Partial<AddVersion>){
        this.addVersionData = { ...this.addVersionData, ...changes };
    }

    addChildForm(name: string, group: FormGroup) {
        this.form.addControl(name, group);
    }

    onFeedbackOptionsChange(feedback_type: string) {
        // when upload-version mode change the message
        let labels = this.project ? this.project.labels.map((l: Objects.Label) => l.name).join(", ") : this.partialProject.labels.map((l: Objects.Label) => l.name).join(", ");
        // console.debug(" main feedback onFeedbackOptionsChange => ", feedback_type);
        switch (feedback_type) {
            case this.FEEDBACK_TYPE_ARTWORK:
                this.messageDefaultPlaceholder = "Please provide a new version."
                this.subject = this.user.name + " is requesting a new version for " + labels;
                break;
            case this.FEEDBACK_TYPE_APPROVAL:
                this.subject = this.user.name + " is requesting your approval on " + labels;
                this.messageDefaultPlaceholder = "Please see files for you to review."
                break;
            case this.FEEDBACK_TYPE_COMMENTS:
            default:
                this.subject = this.user.name + " is requesting your feedback on " + labels;
                this.messageDefaultPlaceholder = "Please see files for you to review."
                break;
        }

    }
    onSignatureChange(e) {
        // console.debug(" main feedback onSignatureChange");
    }
    onStatusSelect(status: SelectItem) {
        this.selectedStatus = status.value;
        // console.debug(" main feedback status change", status, this.selectedStatus);
    }

    // action when push modal buton when error
    onError() {
        console.debug(" Error modal clicked");
        // this.form.get('emails').setValue([]); // clean emails list to force review data and hide button
        this.view = this.VIEW_SENDER;
        this.status = this.DONE
    }

    onSent() {
        console.debug(" Sent modal clicked ");

        this.cancel();
        if (this.lastSuccessfulNavigation) {
            this.location.back();
        } else {
            console.debug('There is no previous navigation state.');
            this.view = this.VIEW_DONE;
        }
    }

    closeModal() {
        this.view = this.VIEW_SENDER;
        this.submitted =  false;
    }

    getMaxEmails(): number {
        // Logic to determine the max emails based on the radio button value fot feedback type
        const feedbackMode = this.form.get('feedback_type')?.value;
        if( feedbackMode == this.FEEDBACK_TYPE_ARTWORK)
            return 1;
        return 0;

    }

    // with this works the selected items in nav according activeRoute.
    protected updateMenu(project: Objects.Request){
        if( project == null)
            return;

        this.menuProjects = projectDetailsMenu.map((item: MenuItem) => {
            return {...item, link: item.link.replace(':id', project.id.toString()) }
        });
    }



}
